'use strict';
const updateAttributeDescriptions = {
		position: 'moved {quantity} node{plural}',
		icon: 'changed {quantity} node image{plural}',
		attachment: 'changed {quantity} node attachment{plural}',
		style: 'changed {quantity} node style{plural}',
		note: 'changed {quantity} node note{plural}',
		theme: 'changed the map theme',
		storyboards: 'updated the storyboard',
		'storyboard-scenes': 'updated the storyboard',
		'previous-atlas-export': 'published the map',
		'measurements-config': 'configured map measurements',
		'measurements': 'changed {quantity} node measurement{plural}'
	},
	simpleCommands = {
		'undo': 'reversed {quantity} change{plural}',
		'redo': 'reversed an undo',
		'paste': 'pasted from clipboard',
		'removeLink': 'removed {quantity} link{plural}',
		'addLink': 'added {quantity} link{plural}',
		'updateLinkAttr': 'changed {quantity} link{plural}',
		'positionBefore': 'moved {quantity} node{plural}',
		'changeParent': 'moved {quantity} node{plural}',
		'insertIntermediate': 'added {quantity} node{plural}',
		'removeSubIdea': 'deleted {quantity} node{plural}',
		'addSubIdea': 'added {quantity} node{plural}',
		'updateTitle': 'updated node text',
		'initialiseTitle': 'updated node text',
		'flip': 'moved {quantity} node{plural}'
	},
	attributeUpdateDescription = function (propName, propValue) {
		if (propName === 'collapsed') {
			if (propValue) {
				return 'folded {quantity} subtree{plural}';
			} else {
				return 'unfolded {quantity} subtree{plural}';
			}
		}
		return updateAttributeDescriptions[propName] || 'updated {quantity} node{plural}';
	},
	pluralise = (text, count) => {
		if (count === 1) {
			return text.replace('{quantity}', 'a').replace('{plural}', '');
		} else {
			return text.replace('{quantity}', count).replace('{plural}', 's');
		}
	},
	getDescriptionTemplate = (cmd, args) => {
		if (cmd === 'updateAttr') {
			return attributeUpdateDescription(args[1], args[2]) || '';
		}
		if (['updateTitle', 'initialiseTitle'].includes(cmd)) {
			if (args && args.length && args.length > 1) {
				return `updated node text to ${args[1]}`;
			} else {
				return 'updated node text';
			}
		}
		return simpleCommands[cmd] || '';
	};

module.exports = function getEventDescription(cmd, args) {
	if (cmd === 'batch') {
		const countByText = args.map(evtArr => getDescriptionTemplate(evtArr[0], evtArr.slice(1)))
			.filter(exists => exists)
			.reduce((a, c) => {
				a[c] = a[c] ? a[c] + 1 : 1;
				return a;
			}, {});
		return Object.keys(countByText).map(text => pluralise(text, countByText[text]))
			.join(', ');
	} else {
		return pluralise(getDescriptionTemplate(cmd, args), 1);
	}
};

